export default "__VITE_ASSET__DOAshxWL__"